import { put, call, delay } from 'redux-saga/effects';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';
import addSortQuery from '../../../utils/addSortQuery';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { MODULE_DTO } from '../constants';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK } from '../../../configs/serverStatusCodes';
import { loadRoleListFailed, loadRoleListSuccessful, loadRoleListBegin } from '../actions';
import ListDTO from '../../../dto/ListDTO';

export default function* loadRoleList(action) {
  try {
    const url = `${BACKEND_URL}/roles`;
    const pool = {};
    yield put(loadRoleListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadRoleListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadRoleListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadRoleListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
